import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import {
  AutoFormControlPopupTreeNode,
  convertArrayToTree
} from '@muchencute/mrrs-types';
import { map, tap } from 'rxjs/operators';
import { ProductCatalog } from './product-models';
import { CORE_CONFIG } from '../environment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ProductCatalogService {

  tree = new BehaviorSubject<AutoFormControlPopupTreeNode[]>([]);

  raw = new BehaviorSubject<any[]>([]);

  private _baseURL: string;

  static _calculateProductCount(tree: AutoFormControlPopupTreeNode[]): AutoFormControlPopupTreeNode[] {

    const _getChildrenProductCount = (node: AutoFormControlPopupTreeNode) => {
      let count = 0;
      node.children.forEach(c => {
        if (!_.isEmpty(c.children)) {
          c.data.productcount = (c.data.productcount || 0) + _getChildrenProductCount(c);
        }
        count += c.data.productcount || 0;
      });
      return count;
    };

    tree.forEach(n => {
      n.data.productcount = (n.data.productcount || 0) + _getChildrenProductCount(n);
    });
    return tree;
  }

  constructor(private httpClient: HttpClient,
              @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/productcatalog`;
    this.getCatalogs().subscribe();
  }

  newCatalog(productCatalog: ProductCatalog): Observable<ProductCatalog> {
    productCatalog.parent = productCatalog.parent || 0;
    return this.httpClient.post<ProductCatalog>(`${this._baseURL}`, productCatalog);
  }

  updateCatalog(productCatalog: ProductCatalog): Observable<any> {
    return this.httpClient.put(`${this._baseURL}/${productCatalog.id}`, productCatalog);
  }

  removeCatalog(id: number): Observable<any> {
    return this.httpClient.delete(`${this._baseURL}/${id}`);
  }

  getCatalogs(): Observable<any> {
    return this.httpClient.get(`${this._baseURL}s`).pipe(
      tap((items: any[]) => this.raw.next(items)),
      map((items: any[]) => ProductCatalogService._calculateProductCount(convertArrayToTree(items))),
      tap(tree => this.tree.next(tree))
    );
  }

  getCatalogsTemporary(params: { [name: string]: string }): Observable<AutoFormControlPopupTreeNode[]> {
    return this.httpClient.get(`${this._baseURL}s`, { params }).pipe(
      tap((items: any[]) => this.raw.next(items)),
      map((items: any[]) => ProductCatalogService._calculateProductCount(convertArrayToTree(items)))
    );
  }

  mergeCatalogs(id: number, toId: number): Observable<any> {
    return this.httpClient.put<any>(`${this._baseURL}/${id}/tocatalog/${toId}`, {}).pipe(
      map((items: any[]) => convertArrayToTree(items)),
    );
  }

}
